import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {CellsContext} from '../../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ViewerPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {ToolbarButton} from '../../../../../../libs/shared/ui/src/components/buttons/toolbarButton';
import {UserThemeConsumer} from '../../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {ConversationBaseModel, ConversationModel} from '../../../../../models/api/conversationModel';
import {InboxesParameters} from '../../../../../store/panels/inboxes/parameters/inboxesParameters';
import {ConversationsMoreButtonProps} from '../actions/more/conversationsMoreCoordinator';
import {ConversationsMoreCoordinatorContainer} from '../actions/more/conversationsMoreCoordinatorContainer';

/*
 * Props.
 */

interface ConversationTopbarMoreProps {
  panelId: ViewerPanelId;
  cellsContext: CellsContext;
  inboxesParameters: InboxesParameters;
  onlyConversation: ConversationModel | undefined;
  conversations: ReadonlyArray<ConversationBaseModel>;
  isBulkActionRequired: boolean;
}

/*
 * Component.
 */

export const ConversationTopbarMore: FC<ConversationTopbarMoreProps> = (props) => (
  <ConversationsMoreCoordinatorContainer
    cellsContext={props.cellsContext}
    inboxesParameters={props.inboxesParameters}
    onlyConversation={props.onlyConversation}
    conversations={props.conversations}
    isBulkActionRequired={props.isBulkActionRequired}
    panelId={props.panelId}
    renderButton={(buttonProps) => renderButton(buttonProps, props)}
    hasSubscribeItem
  />
);

/*
 * Helpers.
 */

function renderButton(buttonProps: ConversationsMoreButtonProps, props: ConversationTopbarMoreProps) {
  return (
    <UserThemeConsumer>
      {(theme) => (
        <ToolbarButton
          iconName="moreVertical"
          label={<Trans id="toolbar-topbar-more">More</Trans>}
          hasHover={buttonProps.hasHover}
          renderTooltip={() => <Trans id="toolbar-topbar-more">More</Trans>}
          color={theme.greys.shade80}
          hoverColor={theme.greys.shade80}
          ref={buttonProps.buttonRef}
          onClick={buttonProps.onClick}
          interactionId="topbarMoreButton"
          noMargin
        />
      )}
    </UserThemeConsumer>
  );
}
